
import logoProfuturo from '@assets/logos/profuturo-logo.png'
import logoProfuturoSmall from '@assets/logos/profuturo-logo-small.png'
import { ClientConfigInfo, FILTER_TYPES, METADADATA_LOAD, SurveyResponsesTab } from './configCommons'
import { DASHBOARDS, DASHBOARDS_CONFIGS } from '../dashboard/dashboardCommons'
import { profuturoStaticDashboards } from '../dashboard/profuturo/staticDashboards'
import deafultHelpDefinition from '../help/defaultHelp'
import { omoikaneProfuturo } from '../omoikane/omoikaneProfuturo'
import { getChildrens } from '@utils/CriticalMomentUtils'
import useClientConfig from '../useClientConfig'

export const getProfuturoFilterCriticalMoments = (filtersData: Record<string, any>, userProfiles: UserProfile[], selectType: String): CriticalMoment[] => {
  if (selectType === 'tree') {
    return filtersData.criticalMoments;
  }

  const { getCriticalMomentsRootId } = useClientConfig()

  const general = {
    id: getCriticalMomentsRootId(),
    name: 'Todos',
    description: 'Todos'
  }

  const cms = getChildrens(filtersData.criticalMoments)

  const sortedCms = cms
    ?.filter((cm: any) => cm?.id !== 10367 && cm?.id !== 11251)
    ?.sort((a: any, b: any) => a.description > b.description
      ? 1 : (a.description < b.description ? -1 : 0))

  // @ts-ignore
  return [general, ...sortedCms,]

}


export const getProfuturoFilterCriticalMomentDefault = (filtersData: Record<string, any>): number => {
  const { getCriticalMomentsRootId } = useClientConfig()
  return getCriticalMomentsRootId()
}

const getTomorrowDate = (): string => {
  const today = new Date()
  today.setDate(today.getDate() + 1)
  return today.toISOString().split('T')[0]
}

const getExtrasFechas = () => {
  return {
    dateFrom: '2018-01-01',
    dateTo: getTomorrowDate(),
    periods: 20
  }
}

export const profuturoConfigs: ClientConfigInfo = {
  vocBackendUrl: 'https://profuturo-backend-voc.limetropy.com/api/',
  lcmBackendUrl: 'https://profuturo-backend-core.limetropy.com/api/ui/',
  caseBackendUrl: 'https://profuturo-backend-case.limetropy.com/api/ui/',
  //vocBackendUrl: 'http://localhost:9000/api/',
  publicUrl: '/voc',
  logoSmall: logoProfuturoSmall,
  logo: logoProfuturo,
  filtersFromDateSubstract: 1,
  filtersToDateSubstract: 0,
  filters: [
    FILTER_TYPES.DATES,
    FILTER_TYPES.CRITICAL_MOMENTS,
    FILTER_TYPES.DYNAMIC
  ],
  supportsInternationalization: false,
  msExcelReportExt: 'xlsx',
  decimals: 0,
  menuDashboards: [DASHBOARDS.DEFAULT],
  sentimentCommentsIndicatorName: 'SENTIMENT_COMMENTS',
  getFilterCriticalMoments: getProfuturoFilterCriticalMoments,
  getFilterCriticalMomentDefault: getProfuturoFilterCriticalMomentDefault,
  geosRootId: 1,
  logicalsRootId: 0,
  criticalMomentsRootId: 0,
  criticalMomentFilterType: 'select',
  showUsersHierarchy: true,
  actionPlans: {
    geoLeafLevel: '',
    useWorstTags: true
  },
  omoikane: omoikaneProfuturo,
  useBackDashboards: true,
  staticDashboards: profuturoStaticDashboards,
  metadata: [
    METADADATA_LOAD.CRITICAL_MOMENTS,
    METADADATA_LOAD.DYNAMIC_REPORT_FIELDS,
    //METADADATA_LOAD.WORKFLOWS
  ],
  dashboards: {
    ...DASHBOARDS_CONFIGS.profuturo,
    default: DASHBOARDS_CONFIGS.profuturo[DASHBOARDS.DEFAULT]
  },
  dashboardCustomFilters: {
    '173004203': getExtrasFechas(),
    '173004205': getExtrasFechas(),
    '173004204': getExtrasFechas(),
  },
  useDashboardDynamicPosition: true,
  surveyResponses: {
    url: 'survey-responses',
    type: 'post',
    tableColumns: undefined,
    tabs: [SurveyResponsesTab.ANSWERED],
    indicators: {
      nps: 'NPS_GENERAL'
    },
  },
  alerts: {
    useAlertWorkflows: true
  },
  notificationsConfig: {
    enabled: true
  },
  help: deafultHelpDefinition,
  assistantConfig: {
    enable: true,
    buttonText: "💬",
    tenant: "profuturo"

  }
}
